webpackJsonp([136993488527921],{

/***/ 23:
/***/ (function(module, exports) {

	module.exports = {"data":[]}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Calendar.tsx
	 * -> Renders a calendar that uses the current calendar.json data as input.
	 */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var CalendarEvent_1 = __webpack_require__(54);
	__webpack_require__(87);
	// Import the current calendar data
	var calendarData = __webpack_require__(23).data;
	calendarData = calendarData.sort(function (a, b) {
	    return new Date(a.start.dateTime).getTime() - new Date(b.start.dateTime).getTime();
	});
	/**
	 * Returns a formatted data string.
	 * @param date inputted Date object
	 */
	function formatAMPM(date) {
	    var hours = date.getHours();
	    var minutes = String(date.getMinutes());
	    var ampm = hours >= 12 ? "pm" : "am";
	    hours = hours % 12;
	    hours = hours ? hours : 12;
	    minutes = Number(minutes) < 10 ? '0' + minutes : minutes;
	    var strTime = hours + ":" + minutes + " " + ampm;
	    return strTime;
	}
	var Calendar = function Calendar() {
	    return React.createElement("div", { className: "calendar__container" }, React.createElement("div", { className: "calendar" }, React.createElement("div", { className: "calendar__header" }, React.createElement("div", { className: "calendar__count" }, calendarData.length, " upcoming event", calendarData.length > 1 ? 's' : null)), React.createElement("div", { className: "calendar__list" }, calendarData.map(function (event) {
	        var startDate = new Date(event.start.dateTime);
	        var month = startDate.toLocaleString('en-us', { month: "short" });
	        var day = startDate.toLocaleString('en-us', { day: "numeric" });
	        var time = formatAMPM(startDate);
	        // Default calendar type to social
	        var type = 'social';
	        // Super-basic, but good enough for now:
	        if (event.summary.toLowerCase().indexOf('workshop') !== -1) {
	            type = 'workshops';
	        } else if (event.summary.toLowerCase().indexOf('speaker') !== -1) {
	            type = 'speakers';
	        }
	        // Check if there's a link included
	        var urlRegex = /(https?:\/\/[^\s]+)/g;
	        var url = urlRegex.exec(event.description);
	        var parsedDescription = event.description ? event.description.replace(urlRegex, "") : "";
	        return React.createElement(CalendarEvent_1.default, { key: event.summary, month: month, day: day, time: time, type: type, url: url && url[0], title: event.summary, location: event.location, description: parsedDescription });
	    }))), React.createElement("div", { className: "calendar__meta" }, React.createElement("a", { href: "https://calendar.google.com/calendar?cid=c3RhbmZvcmQuZWR1X2RoNHZ1bW1la242M2RwOWd0aGxlMWw3cG0wQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20", rel: "noopener noreferrer", target: "_blank" }, React.createElement("span", null, "\uD83D\uDDD3"), " Follow our calendar ", React.createElement("small", null, "\u2197"))));
	};
	exports.default = Calendar;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * CalendarEvent.tsx
	 * -> Used by <Calendar> to display an event item.
	 */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var Calendar = function Calendar(props) {
	    // If we get a link in our props, we render the component as a link to the event url (likely a FB event).
	    if (props.url) {
	        return React.createElement("a", { href: props.url, key: props.title, title: 'View event page ↗', className: 'calendar__event calendar__event-link calendar__event--' + props.type, rel: "noopener noreferrer", target: "_blank" }, React.createElement("div", { className: "calendar__event-dashes" }), React.createElement("div", { className: "calendar__event-date" }, React.createElement("div", { className: "calendar__event-month" }, props.month), React.createElement("div", { className: "calendar__event-day" }, props.day)), React.createElement("div", { className: "calendar__event-content" }, React.createElement("h1", { className: "calendar__event-title" }, props.title), React.createElement("h2", { className: "calendar__event-meta" }, props.time, "  \xB7  ", props.location), props.description.split("\n").map(function (text, index) {
	            return React.createElement("p", { key: index, className: "calendar__event-description" }, text);
	        })), React.createElement("div", { className: "calendar__event-icon" }));
	    } else {
	        return React.createElement("div", { key: props.title, className: 'calendar__event calendar__event--' + props.type }, React.createElement("div", { className: "calendar__event-dashes" }), React.createElement("div", { className: "calendar__event-date" }, React.createElement("div", { className: "calendar__event-month" }, props.month), React.createElement("div", { className: "calendar__event-day" }, props.day)), React.createElement("div", { className: "calendar__event-content" }, React.createElement("h1", { className: "calendar__event-title" }, props.title), React.createElement("h2", { className: "calendar__event-meta" }, props.time, "  \xB7  ", props.location), React.createElement("p", { className: "calendar__event-description" }, props.description)), React.createElement("div", { className: "calendar__event-icon" }));
	    }
	};
	exports.default = Calendar;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Events.tsx
	 */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var Calendar_1 = __webpack_require__(53);
	var PageHeader_1 = __webpack_require__(36);
	var calendarData = __webpack_require__(23).data;
	var EventPage = function EventPage() {
	    return React.createElement("div", { className: "page" }, React.createElement(PageHeader_1.default, { title: "Upcoming Events", subtitle: "All of SAIG's events are open to the public. Unless otherwise specified below, there are no requirements or preparations required before you come!" }), React.createElement("br", null), React.createElement(Calendar_1.default, null));
	};
	exports.default = EventPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-tsx-796085df14f9ead54cd7.js